export const LinkInvoice = ({ size = "24" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.0001" cy="12" r="10" fill="#9254E5" fill-opacity="0.5" />
      <circle
        cx="12.0001"
        cy="12"
        r="10"
        fill="url(#paint0_linear_6844_3718)"
      />
      <path
        d="M10.2857 13.7159C10.1911 13.6213 10.1022 13.5176 10.022 13.4082C9.88825 13.2246 9.92858 12.9671 10.1125 12.8333C10.296 12.6996 10.5532 12.7399 10.6873 12.9235C10.7404 12.9967 10.8001 13.0671 10.8671 13.1337C11.1975 13.4641 11.6366 13.646 12.1036 13.646C12.5706 13.646 13.0101 13.4641 13.3401 13.1337L15.6031 10.8706C16.2849 10.1888 16.2849 9.0791 15.6031 8.3973C14.9213 7.71549 13.8116 7.71549 13.1298 8.3973L12.6945 8.83263C12.5336 8.99352 12.2735 8.99352 12.1127 8.83263C11.9518 8.67175 11.9518 8.4117 12.1127 8.25081L12.548 7.81548C13.5507 6.81232 15.1822 6.81232 16.185 7.81548C17.1877 8.81823 17.1877 10.4497 16.185 11.4525L13.9219 13.7155C13.4363 14.2015 12.7903 14.4689 12.1036 14.4689C11.4169 14.4689 10.7709 14.2015 10.2857 13.7159ZM9.63479 16.9377C10.3219 16.9377 10.9675 16.6703 11.4531 16.1843L11.8884 15.749C12.0493 15.5885 12.0493 15.3281 11.8884 15.1672C11.7279 15.0063 11.4675 15.0067 11.3066 15.1672L10.8708 15.6025C10.5404 15.9329 10.1014 16.1148 9.63438 16.1148C9.16736 16.1148 8.72832 15.9329 8.39791 15.6025C8.06751 15.2721 7.88564 14.8331 7.88564 14.3661C7.88564 13.899 8.06751 13.4596 8.39791 13.1296L10.661 10.8665C10.9914 10.5361 11.4304 10.3542 11.8975 10.3542C12.3645 10.3542 12.8039 10.5361 13.1339 10.8665C13.1998 10.9328 13.2598 11.0031 13.3133 11.0764C13.4466 11.2603 13.7038 11.3014 13.8881 11.1673C14.0721 11.0336 14.1128 10.7764 13.9791 10.5925C13.9009 10.4847 13.8124 10.3814 13.7161 10.2851C13.2302 9.79876 12.5842 9.5313 11.8975 9.5313C11.2107 9.5313 10.5647 9.79876 10.0792 10.2847L7.81651 12.5478C7.33056 13.0333 7.06311 13.6793 7.06311 14.3661C7.06311 15.0528 7.33056 15.6988 7.81651 16.1843C8.30204 16.6703 8.94764 16.9377 9.63479 16.9377Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6844_3718"
          x1="12.0518"
          y1="2"
          x2="22.8269"
          y2="8.62105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B29BFF" />
          <stop offset="1" stop-color="#8064DE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
